export default __webpack_public_path__ + "static/media/image-frame-1.23398e93.jpg";